// 貸主・所有者・管理会社情報
const ModalBuildingEditorKsk = {
  namespaced: true,

  state: {
    // 建物側の取引情報を編集するモーダル
    modal: false,
    itemKashi: {},
    itemShoyu: {},
    itemKanri: {},
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getItemKashi: state => {
      return state.itemKashi
    },
    getItemShoyu: state => {
      return state.itemShoyu
    },
    getItemKanri: state => {
      return state.itemKanri
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setItemKashi(state, item) {
      state.itemKashi = item
    },
    setItemShoyu(state, item) {
      state.itemShoyu = item
    },
    setItemKanri(state, item) {
      state.itemKanri = item
    },
  },
  actions: {},
}

export default ModalBuildingEditorKsk
